import { rawCacaClient } from '@plangrid-private/web-api-clients';
import useSWR from 'swr';

import { useCurrentProjectId } from '@adsk/alloy-provider';

import { FORMS_SWR_CONFIG } from '../helpers/constants';
import { getProjectUserUrl } from '../helpers/utils';

export default () => {
  const projectId = useCurrentProjectId();
  const { data, error } = useSWR(
    getProjectUserUrl(projectId),
    (url) => {
      return rawCacaClient
        .get({
          url,
        })
        .then((projectUser) => projectUser);
    },
    FORMS_SWR_CONFIG,
  );

  return {
    data,
    isError: error,
    isLoading: !error && !data,
  };
};
